import { Card, StatusTag } from '@paysera/ui';
import { useTranslation } from 'react-i18next';
import { getScheduleStatusVariant } from '@modules/borrower/utils/getScheduleStatusVariant';
import { DetailRow } from '@modules/investor/components/common/DetailRow';
const PaymentsScheduleMobile = ({ scheduleItems }) => {
    const { t } = useTranslation();
    return (<div className="flex flex-col gap-4">
            {scheduleItems.map((item) => {
            const statusVariant = getScheduleStatusVariant(item.status);
            const statusLabel = t(`financing.loan_status.${item.status.toLowerCase()}`);
            return (<Card key={item.id} className="flex flex-col gap-4">
                        <div className="flex flex-col gap-4">
                            <DetailRow label={t('financing.payments_schedule.number')} value={item.position}/>
                            <DetailRow label={t('financing.payments_schedule.payment_date')} value={item.date}/>
                            <DetailRow label={t('financing.payments_schedule.status')} value={statusVariant ? (<StatusTag variant={statusVariant} label={statusLabel} isFilledIcon={false}/>) : (statusLabel)}/>
                            <DetailRow label={`${t('financing.payments_schedule.amount')}, €`} value={`${item.amount} €`}/>
                            <DetailRow label={`${t('financing.payments_schedule.interest')}, €`} value={`${item.interest} €`}/>
                            <DetailRow label={`${t('financing.payments_schedule.admin_fee')}, €`} value={`${item.administratorFee} €`}/>
                            <DetailRow label={t('financing.payments_schedule.overdue_days')} value={item.overdueDays}/>
                            <DetailRow label={`${t('financing.payments_schedule.late_fees')}, €`} value={`${item.lateFee} €`}/>
                            <DetailRow label={`${t('financing.payments_schedule.sum')}, €`} value={<span className="font-semibold">{`${item.sum} €`}</span>}/>
                        </div>
                    </Card>);
        })}
        </div>);
};
export default PaymentsScheduleMobile;
